<script setup lang="ts">
import { protocol } from '@/api/common';
import { ref } from 'vue';
import { onBeforeMount } from 'vue';

const { type } = defineProps(['type']);
const richText = ref();

onBeforeMount(() => {
  protocol({
    type,
  })
    .then((res) => {
      richText.value = res;
    })
    .catch((err) => {
      console.error(err);
    });
});
</script>

<template>
  <div class="protocol ql-editor" v-html="richText"></div>
</template>

<style lang="scss" scoped>
.protocol {
  width: 100%;
  height: calc(100% - 70px);
  padding: 0 260px;
  margin-top: 10px;
  box-sizing: border-box;
  overflow-y: auto;
  color: #1f1d29;
  line-height: 1.75;

  :deep(img) {
    max-width: 100%;
    height: auto;
  }

  :deep(p),
  :deep(li) {
    word-break: break-word;
  }

  :deep(table) {
    max-width: 100%;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .protocol {
    height: calc(100% - 1.5rem);
    margin-top: 0;
    padding: 1.5rem 3rem 3rem;
    font-size: 0.9375rem;

    :deep(.ql-align-center img),
    :deep(p img) {
      max-width: min(100%, 42rem);
    }
  }
}

@media (max-width: 767px) {
  .protocol {
    min-height: calc(100vh - 3.5rem);
    height: auto;
    margin-top: 0;
    padding: 1.25rem 1rem 3rem;
    overflow: visible;
    font-size: 0.92rem;
    line-height: 1.7;

    :deep(h1) {
      font-size: 1.45rem;
      line-height: 1.35;
      margin: 0.4rem 0 1rem;
    }

    :deep(h2) {
      font-size: 1.2rem;
      line-height: 1.4;
      margin: 1.15rem 0 0.65rem;
    }

    :deep(h3) {
      font-size: 1.05rem;
      line-height: 1.45;
      margin: 1rem 0 0.5rem;
    }

    :deep(p),
    :deep(li) {
      font-size: 0.92rem;
      line-height: 1.7;
    }

    :deep(ol),
    :deep(ul) {
      padding-left: 1.1rem;
    }

    :deep(img) {
      width: auto !important;
      max-width: 100% !important;
    }
  }
}
</style>
